import { render, staticRenderFns } from "./NationalChildDetail.vue?vue&type=template&id=5bd5ac79&scoped=true"
var script = {}
import style0 from "./NationalChildDetail.vue?vue&type=style&index=0&id=5bd5ac79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd5ac79",
  null
  
)

export default component.exports